export default __webpack_public_path__ + "static/media/brand-21.d918e379.png";